<template lang="pug">
v-dialog(v-model="dialogAdd" width="700" persistent)
    template(v-slot:activator="{ on, attrs }")
        v-btn.ml-2(v-if="!itemIsNull" small color="blue" dark v-bind="attrs" v-on="on")
            v-icon(small) mdi-square-edit-outline
        v-btn.ml-10(v-else small color="green" dark v-bind="attrs" v-on="on")
            v-icon(small) mdi-plus-circle
            | &nbsp; Add New Points Trigger

    v-card
        v-card-title {{ itemIsNull ? 'Add New' : 'Update' }}  Points Trigger
        v-card-text
            v-text-field(label="Name" v-model="form.name" :disable="dialogAddLoading")
            v-text-field(label="Description" v-model="form.description" :disable="dialogAddLoading")
            v-text-field(type="number" label="Points" v-model="form.points" :disable="dialogAddLoading")
            feathers-vuex-find(service="service-lists" :query="{}")
                v-combobox(slot-scope="{ items }" v-model="form.hook" label="Target Service" :items="servicesFilter(items)" :disable="dialogAddLoading")
            v-combobox(v-model="form.hookType" label="Method" :items="methodOptions" :disable="dialogAddLoading")
            
        v-divider
        v-card-actions
            v-spacer
            v-btn(v-if="!dialogAddLoading" small color="red" text @click="dialogAdd = false") Cancel
            v-btn(small color="primary" text @click="addPointTrigger" :loading="dialogAddLoading") Submit
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        item: {
            type: Object,
            default() {
                return {
                    name: null,
                    description: null,
                    points: 0,
                    hook: null,
                    hookType: null,
                };
            }
        }
    },
    data() {
        return {
            dialogAdd: false,
            dialogAddLoading: false,
            form: {
                name: this.item.name,
                description: this.item.description,
                points: this.item.points,
                hook: this.item.hook,
                hookType: this.item.hookType
            },
            successMessage: false,
            error: {
                show: false,
                message: ''
            }
        };
    },
    computed: {
        methodOptions() {
            return [
                { id: 'CREATE', text: 'Create' },
                { id: 'UPDATE', text: 'Update' }
            ];
        },
        itemIsNull() {
            return !this.item || !this.item.name && !this.item.description;
        }
    },
    methods: {
        async addPointTrigger() {
            try {
                if(this.itemIsNull) {
                    await this.createPointTrigger({
                        ...this.form,
                        hookType: this.form.hookType.id
                    });
                    this.$emit('success')
                    this.form.name = '';
                    this.form.description = '';
                    this.form.points = '';
                    this.form.hook = null;
                    this.form.hookType = null;
                    this.dialogAdd = false;
                } else {
                    this.item.name = this.form.name;
                    this.item.description = this.form.description;
                    this.item.points = this.form.points;
                    this.item.hook = this.form.hook;
                    this.item.hookType = this.form.hookType.id;
                    await this.item.patch();
                    this.$emit('success');
                    this.dialogAdd = false;
                }
            } catch(err) {
                this.$emit('error', err)
            }
        },
        servicesFilter(items) {
            return [
                'authentication',
                ...(items.map(i => i.id).filter(service => [
                    'logic-control',
                    'cities',
                    'countries',
                    'regions',
                    'logic-control-category',
                    'bh-app-error-log',
                    'bh-app-version',
                    'bh-exp-tables',
                    'access-control-services',
                    'bh-user-obtained-exp',
                    'bh-exp-hooks'
                ].indexOf(service) === -1))
            ];
        },
        ...mapActions('bh-points-map', { createPointTrigger: 'create' })
    }
}
</script>